<template>
  <div class="bdgWrp">
    <div class="inner">
      <el-table
          :data="tableData"
          style="width: 100%">
        <el-table-column
          width="143"
          prop="location"
          label="OPERATIONAL UNIT">
        </el-table-column>
        <el-table-column
          width="160"
          prop="area"
          label="AREA">
        </el-table-column>
        <el-table-column
          width="100"
          prop="salaried"
          label="SALARIED">
          <template slot-scope="scope">
            <div v-if="scope.row.salaried === 1">Full Time</div>
            <div v-else-if="scope.row.salaried === 2">Part Time</div>
            <div v-else-if="scope.row.salaried === 3">Casual</div>
          </template>
        </el-table-column>
        <el-table-column
          width="198"
          prop="employee"
          label="EMPLOYEE">
        </el-table-column>
        <el-table-column
          width="120"
          prop="startTime"
          label="START TIME">
        </el-table-column>
        <el-table-column
          width="100"
          prop="endTime"
          label="END TIME">
        </el-table-column>
        <el-table-column
          width="136"
          prop="mealBreak"
          label="MEAL BREAK">
        </el-table-column>
        <el-table-column
          width="120"
          prop="totalTime"
          label="TOTAL TIME">
        </el-table-column>
        <el-table-column
          width="86"
          prop="cost"
          label="COST">
        </el-table-column>
        <el-table-column
          width="180"
          prop="comment"
          label="COMMENT">
        </el-table-column>
        <template slot="empty">
          <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
          <div v-else>-</div>
        </template>
      </el-table>
      <pageination :total="totalRecord" :size="pagesize" @togglePage="pageChange"></pageination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/account'
import pageination from '../../../components/common/pageination'

export default {
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      pagesize: 10,
      totalRecord: 0
    }
  },
  created() {
    if (!this.$route.params.id || !this.$route.params.time) {
      return
    }
    api.deputyRosterDetail({
      params: {
        date: parseInt(this.$route.params.time),
        pageNum: this.page,
        pageSize: this.pagesize,
        venueId: parseInt(this.$route.params.id)
      },
      callback: this.callback
    })
  },
  methods: {
    callback (res) {
      var that = this
      that.loading = false
      if(res.data.code == 0){
        // 差这里
        res.data.data.list.forEach(item => {
          item.startTime = that.$box.getDateFormat(item.startTime * 1000)
          item.endTime = that.$box.getDateFormat(item.endTime * 1000)
          item.mealBreak = that.$box.getDateFormat(item.mealBreak * 1000)
          item.cost = this.$box.formatDecimal2(item.cost, 2)
        })
        that.tableData = res.data.data.list
        that.totalRecord = res.data.data.total
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    pageChange (page) {
      this.tableData = []
      this.loading = true
      this.page = page
      api.deputyRosterDetail({
      params: {
          date: parseInt(this.$route.params.time),
          pageNum: this.page,
          pageSize: this.pagesize,
          venueId: parseInt(this.$route.params.id)
        },
        callback: this.callback
      })
    }
  },
  components: {
    pageination
  }
}
</script>

<style lang="scss" scoped>
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
  .inner{
    min-width: 820px;
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/DeRoster/detail.vue